import { React, Suspense, lazy, useEffect } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from "history";
// import SpinnerLoader from './components/common/spinner';
// import SearchFormContainerNew from './pages/flights/home/SearchFormContainerNew';
import SsoAuthContainer from "./pages/flights/home/ssoAuthContainer"
import BookingConfirmationContainer from "./pages/flights/bookingConfirmation/BookingConfirmationContainer"
import LoginContainer from './pages/flights/home/LoginContainter'

import { ProtectedRoutes } from './ProtectedRoutes';
import { useSharedChrome } from './hooks/useSharedChrome';
import IntermediateBookingConfirmation from './pages/flights/bookingConfirmation/IntermediateBookingConfirmation';
import GoldenticketLogin from './pages/flights/home/Goldenticket';
import AgentRegister from './pages/flights/home/AgentRegister';
import { setFlightType } from './appStore/actionCreators/searchForm';
import { prefetchCityAirports } from './appStore/thunks/getCityAirport';
// const BookingConfirmationContainer = lazy(() => './pages/flights/bookingConfirmation/BookingConfirmationContainer') 
const ResultsContainer = lazy(() => import("./pages/flights/results/ResultsContainer"));
const ResultsContainerFlexiDate = lazy(() => import("./pages/flights/results/ResultsContainerFlexiDate"));
const BookingResultContainer = lazy(() => import("./pages/flights/booking/bookingResultContainer"));
const HeaderMyfiles = lazy(() => import("./components/homePageHeader/myFiles/headerMyFiles"));
const SavedQuoteDetails = lazy(() => import("./components/homePageHeader/mySavedQuotes/SavedQuoteDetails"));
const PaymentDetailContainer = lazy(() => import("./pages/flights/paymentDetail/PaymentDetailContainer"));
const MySavedQuotes = lazy(() => import("./components/homePageHeader/mySavedQuotes/MySavedQuotes"));
const BrandedFareContainer = lazy(() => import("./pages/flights/brandedFare/BrandedFareContainer"));
const BookingCancellationContainer = lazy(() => import("./pages/flights/bookingConfirmation/BookingCancellationContainer"));
const CalculatorContainer = lazy(() => import("./pages/flights/home/CalculatorContainer"));
const CalculatorBrandedFareContainer = lazy(() => import("./pages/flights/home/CalculatorBrandedFareContainer"));
const BlockSpaceContainer = lazy(()=> import("./pages/flights/blockSpace/BlockSpaceContainer"));
const BlockSpaceBookingContainer = lazy(()=> import("./pages/flights/blockSpace/BlockSpaceBookingContainer"));
const BlockSpaceConfirmationContainer = lazy(()=> import("./pages/flights/blockSpace/BlockSpaceConfirmationContainer"));
const BlockSpacePaymentContainer = lazy(()=> import("./pages/flights/blockSpace/BlockSpacePaymentContainer"));
const SearchFormContainerNew = lazy(()=> import("./pages/flights/home/SearchFormContainerNew"));


const history = () => {
	return createBrowserHistory();
};

const HISUK_CONSTANT = "hisuk";
const GOLDENTICKET_CONSTANT = "goldentkt";
let url = window.location.hostname;
window.isHISUK = () => {
	return url?.toLowerCase().includes(HISUK_CONSTANT);
}
window.isGoldenticket = () => {
	return url?.toLowerCase().includes(GOLDENTICKET_CONSTANT);
}

function Routes() {
	const dispatch = useDispatch();
	const flightType = useSelector((state)=>state.searchForm.flightType)
	const orgId = useSelector((state) => state.agentProfile.orgId);
	const isInternalUserAutheticated = useSelector(
		(state) => state.internalUser.isInternalUserAutheticated
	);
	const isAgentAutheticated = useSelector(
		(state) => state.agentProfile.isAgentAutheticated
	);

	useSharedChrome();

	// Prefetch airports only after login (or restored session on refresh).
	useEffect(() => {
		if (isInternalUserAutheticated || isAgentAutheticated) {
			dispatch(prefetchCityAirports());
		}
	}, [isInternalUserAutheticated, isAgentAutheticated, dispatch]);

	useEffect(() => {
		const body = document.querySelector("body");
		if (!body) return;
		const isGoldenTicketBrand = window.isGoldenticket?.();
		body.classList.toggle("goldenticket-brand", Boolean(isGoldenTicketBrand));
		return () => {
			body.classList.remove("goldenticket-brand");
		};
	}, []);

	useEffect(()=>{
		if(window.isHISUK()){
			window.selectedDollarValue = '£'
		}else if(window.isGoldenticket()){
			if (flightType !== "CAD") {
				dispatch(setFlightType("CAD"));
			}
			window.selectedDollarValue = '$'
		}else if(flightType == "CAD"){
			window.selectedDollarValue = '$'
		}
		else{
			window.selectedDollarValue = '$'
		}
	}, [dispatch, flightType])

	return (
		<Suspense
		fallback={
			<div className="col-md-12 text-center mt-3">
					{/* <SpinnerLoader /> */}
				</div>
			}
		>
			<Switch history={history}>

			{window.isHISUK() ? (
				<>
				<Route exact path="/" component={HISUKLogin} />
				<Route exact path="/login" component={HISUKLogin} />
				<Route exact path="/search" component={SearchFormContainerNew} auth={String(orgId).length} />
				<ProtectedRoutes path="/SearchResults" component={ResultsContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/BookingPage" component={BookingResultContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/SearchResultsFlexiDate" component={ResultsContainerFlexiDate} auth={String(orgId).length} />
				<ProtectedRoutes path="/HeaderMyFiles" component={HeaderMyfiles} auth={String(orgId).length} />
				<ProtectedRoutes path="/MySavedQuotes" component={MySavedQuotes} auth={String(orgId).length} />
				<ProtectedRoutes path="/saved-quotes/details" component={SavedQuoteDetails} auth={String(orgId).length} />
				<Route exact path="/booking-confirmation" component={BookingConfirmationContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/payment-details" component={PaymentDetailContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/branded-fare" component={BrandedFareContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/booking-cancellation" component={BookingCancellationContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/calculator" component={CalculatorContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/branded-fare-calculator" component={CalculatorBrandedFareContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/BlockSpace" component={BlockSpaceContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/BlockSpaceBooking" component={BlockSpaceBookingContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/BlockSpaceConfirmation" component={BlockSpaceConfirmationContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/BlockSpacePayment" component={BlockSpacePaymentContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/intermediate-booking-confirmation" component={IntermediateBookingConfirmation} auth={String(orgId).length} />
				</>
			) : window.isGoldenticket() ? (
				<>
				<Route exact path="/" component={GoldenticketLogin} />
				<Route exact path="/login" component={GoldenticketLogin} />
				<Route exact path="/register" component={AgentRegister} />
				<Route exact path="/en/register" component={AgentRegister} />
				<Route exact path="/search" component={SearchFormContainerNew} auth={String(orgId).length} />
				<ProtectedRoutes path="/SearchResults" component={ResultsContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/BookingPage" component={BookingResultContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/SearchResultsFlexiDate" component={ResultsContainerFlexiDate} auth={String(orgId).length} />
				<ProtectedRoutes path="/HeaderMyFiles" component={HeaderMyfiles} auth={String(orgId).length} />
				<ProtectedRoutes path="/MySavedQuotes" component={MySavedQuotes} auth={String(orgId).length} />
				<ProtectedRoutes path="/saved-quotes/details" component={SavedQuoteDetails} auth={String(orgId).length} />
				<Route exact path="/booking-confirmation" component={BookingConfirmationContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/payment-details" component={PaymentDetailContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/branded-fare" component={BrandedFareContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/booking-cancellation" component={BookingCancellationContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/calculator" component={CalculatorContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/branded-fare-calculator" component={CalculatorBrandedFareContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/BlockSpace" component={BlockSpaceContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/BlockSpaceBooking" component={BlockSpaceBookingContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/BlockSpaceConfirmation" component={BlockSpaceConfirmationContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/BlockSpacePayment" component={BlockSpacePaymentContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/intermediate-booking-confirmation" component={IntermediateBookingConfirmation} auth={String(orgId).length} />
				</>
			) :(
				<>
				<Route exact path="/" component={SsoAuthContainer} />
				<Route exact path="/login" component={LoginContainer} />
				<ProtectedRoutes path="/SearchResults" component={ResultsContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/BookingPage" component={BookingResultContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/SearchResultsFlexiDate" component={ResultsContainerFlexiDate} auth={String(orgId).length} />
				<ProtectedRoutes path="/HeaderMyFiles" component={HeaderMyfiles} auth={String(orgId).length} />
				<ProtectedRoutes path="/MySavedQuotes" component={MySavedQuotes} auth={String(orgId).length} />
				<ProtectedRoutes path="/saved-quotes/details" component={SavedQuoteDetails} auth={String(orgId).length} />
				<Route exact path="/booking-confirmation" component={BookingConfirmationContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/payment-details" component={PaymentDetailContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/branded-fare" component={BrandedFareContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/booking-cancellation" component={BookingCancellationContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/calculator" component={CalculatorContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/branded-fare-calculator" component={CalculatorBrandedFareContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/BlockSpace" component={BlockSpaceContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/BlockSpaceBooking" component={BlockSpaceBookingContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/BlockSpaceConfirmation" component={BlockSpaceConfirmationContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/BlockSpacePayment" component={BlockSpacePaymentContainer} auth={String(orgId).length} />
				<ProtectedRoutes path="/intermediate-booking-confirmation" component={IntermediateBookingConfirmation} auth={String(orgId).length} />
				</>
			)}
			</Switch>
		</Suspense>
	)
}

export default Routes;